import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import './services.scss';
import Layout from '../../components/Layout';
import bgim from '../../images/bgth.jpg';
import check from '../../images/check.png';
import pelvic from '../../images/servicetherapy/pelvic floor.jpeg';
import sports from '../../images/servicetherapy/sports rehabilitation.jpeg';
import manual from '../../images/servicetherapy/Manual Therapy.jpeg';
import postsurgical from '../../images/servicetherapy/Post-Surgical Rehabilitation.jpeg';
import Chronic from '../../images/servicetherapy/Chronic Pain Management.jpeg';
import DryNeedling from '../../images/servicetherapy/Dry Needling.jpeg';
import Cupping from '../../images/servicetherapy/Cupping.jpeg';
import TENS from '../../images/servicetherapy/TENS.jpeg';
import EStim from '../../images/servicetherapy/E-Stim.jpeg';
import Kinesiology from '../../images/servicetherapy/Kinesiology.jpeg';
import Heat from '../../images/servicetherapy/Heat and Cold.jpeg';
import QuotesSlider from '../Landingpage/QuotesSlider';

const services = [
  {
    id: 2,
    therapy: "Sports Rehabilitation",
    description: "Sports rehabilitation focuses on recovery and injury prevention related to athletic activities. It helps athletes, from professionals to amateurs, return to peak performance while preventing future injuries.",
    whyChoose: "At MantraFlex, our physiotherapists provide tailored rehabilitation services for injury recovery and performance enhancement. We focus on sport-specific rehabilitation to ensure effective and safe recovery.",
    benefits: [
      "Injury Recovery: Accelerates recovery from injuries like sprains and fractures.",
      "Injury Prevention: Addresses muscle imbalances and joint instability.",
      "Performance Enhancement: Improves flexibility, strength, and movement patterns.",
      "Sport-Specific Training: Provides custom training programs for a safe return to activity."
    ],
    image: sports
  },
  {
    id: 3,
    therapy: "Manual Therapy",
    description: "Manual therapy involves hands-on techniques to manipulate the body’s joints, muscles, and soft tissues to alleviate pain, improve mobility, and reduce tension. It is used to treat musculoskeletal conditions and injuries.",
    whyChoose: "Manual therapy at MantraFlex is tailored to individual needs, whether dealing with neck or back pain, joint stiffness, or soft tissue injuries. Our expert physiotherapists use effective techniques to provide relief and improve movement.",
    benefits: [
      "Pain Relief: Reduces musculoskeletal pain and headaches.",
      "Improved Mobility: Restores range of motion and flexibility.",
      "Muscle Relaxation: Alleviates muscle tightness and spasms.",
      "Joint Stiffness: Helps with arthritis and joint function improvement."
    ],
    image: manual
  },
  {
    id: 4,
    therapy: "Post-Surgical Rehabilitation",
    description: "Post-surgical rehabilitation helps individuals recover after surgery, such as joint replacement or spinal surgery. It aids in restoring function, reducing pain, and preventing complications during recovery.",
    whyChoose: "At MantraFlex, we provide customized post-surgical rehab plans in collaboration with your surgeon, focusing on accelerating healing, restoring strength, and reducing the risk of complications.",
    benefits: [
      "Accelerated Recovery: Speeds up the healing process through early mobilization.",
      "Restoration of Function: Restores strength, range of motion, and stability.",
      "Pain Management: Alleviates pain and swelling during recovery.",
      "Prevention of Complications: Reduces the risk of muscle weakness and stiffness."
    ],
    image: postsurgical
  },
  {
    id: 5,
    therapy: "Chronic Pain Management",
    description: "Chronic pain persists for over 12 weeks and can arise from conditions like arthritis or nerve damage. It can affect both physical and mental well-being, reducing quality of life.",
    whyChoose: "MantraFlex takes a holistic approach to chronic pain management, addressing both the physical and emotional aspects of pain to improve mobility and overall quality of life.",
    benefits: [
      "Comprehensive Pain Relief: Manages pain from conditions like arthritis and fibromyalgia.",
      "Improved Mobility: Increases flexibility and range of motion.",
      "Enhanced Mental Well-being: Alleviates the emotional impact of chronic pain.",
      "Personalized Treatment: Tailored pain management strategies."
    ],
    image: Chronic
  },
  {
    id: 12,
    therapy: 'Electrical Stimulation Therapy',
    description: 'Electrical Stimulation Therapy (E-Stim) uses electrical currents to stimulate muscles, improve muscle strength, and promote muscle function. It can be used to improve neuromuscular function, reduce pain, or prevent muscle atrophy during rehabilitation.',
    benefits: [
      'Promotes muscle contraction and strength',
      'Improves circulation and tissue healing',
      'Reduces muscle atrophy after injury or surgery',
      'Alleviates pain and muscle spasms'
    ],
    whyChoose: 'E-Stim is highly effective for patients recovering from surgery, injury, or stroke. It’s used to stimulate muscles, increase circulation, and reduce muscle wasting or weakness during rehabilitation.',
    image: EStim
  },
  {
    id: 13,
    therapy: 'Kinesiology Taping',
    description: 'Kinesiology taping involves applying a special elastic tape to the skin to support muscles and joints without restricting movement. The tape is designed to mimic the skin’s elasticity, promoting pain relief, reducing swelling, and supporting muscle function during activity.',
    benefits: [
      'Provides muscle and joint support without restricting movement',
      'Reduces swelling and inflammation',
      'Improves circulation and lymphatic drainage',
      'Enhances proprioception and movement awareness'
    ],
    whyChoose: 'This technique is commonly used for athletes and individuals recovering from injuries. Kinesiology taping provides support to muscles and joints while encouraging natural movement and improving proprioception (the body’s sense of position).',
    image: Kinesiology
  },
  {
    id: 14,
    therapy: 'Heat and Cold Therapy',
    description: 'Heat therapy (thermotherapy) uses heat pads, wraps, or warm water to relax muscles and improve blood circulation. Cold therapy (cryotherapy) involves applying ice or cold packs to reduce swelling, numb pain, and manage acute injuries or inflammation.',
    benefits: {
      heatTherapy: [
        'Relieves muscle stiffness and spasms',
        'Improves blood flow to injured areas',
        'Provides relaxation and pain relief'
      ],
      coldTherapy: [
        'Reduces swelling and inflammation',
        'Numbs pain and provides acute injury management',
        'Slows down nerve activity to alleviate pain'
      ]
    },
    whyChoose: 'Both heat and cold therapies are effective for managing different phases of injury recovery. Cold therapy is used during the acute phase to reduce inflammation and pain, while heat therapy is ideal for relaxing muscles and promoting circulation during the healing phase.',
    image: Heat
  }
];

const experties = [
  {
    id: 1,
    therapy: "Pelvic Floor Therapy",
    description: "Pelvic floor therapy is a specialized physiotherapy focusing on muscles, ligaments, and ...",
    whyChoose: "MantraFlex offers expert care for both men and women, creating a safe and supportive environment. We provide education, manual therapy, and personalized exercise regimens to improve pelvic floor muscle strength and coordination.",
    benefits: [
      "Urinary Incontinence: Strengthens pelvic muscles to improve bladder control.",
      "Pelvic Pain Relief: Alleviates chronic pelvic pain caused by various conditions.",
      "Postpartum Recovery: Restores pelvic muscle strength after childbirth.",
      "Sexual Health: Improves muscle tone and coordination for sexual health.",
      "Constipation Relief: Enhances bowel function through pelvic muscle strengthening."
    ],
    image: pelvic
  },
  {
    id: 6,
    therapy: "Dry Needling",
    description: "Dry needling involves inserting fine needles into trigger points in muscles or fascia to relieve ...",
    whyChoose: "MantraFlex uses advanced dry needling techniques as part of a comprehensive treatment plan for musculoskeletal pain, chronic tension, and sports injuries, providing fast and effective relief.",
    benefits: [
      "Pain Relief: Reduces muscle pain and discomfort.",
      "Improved Range of Motion: Restores normal movement and flexibility.",
      "Reduced Muscle Spasms: Alleviates spasms causing pain and restricted movement.",
      "Accelerated Healing: Stimulates blood flow to promote faster recovery.",
      "Chronic Pain Management: Effective for conditions like myofascial pain syndrome."
    ],
    image: DryNeedling
  },
  {
    id: 7,
    therapy: "Cupping Therapy",
    description: "Cupping therapy is an ancient healing practice that involves placing specialized cups on the skin to create ...",
    whyChoose: "MantraFlex uses dry cupping to effectively treat musculoskeletal issues, chronic pain, and muscle stiffness. It complements other therapies and enhances recovery by improving circulation and relieving tension.",
    benefits: [
      "Muscle Relaxation: Releases tight muscles and soft tissues.",
      "Improved Circulation: Draws blood to the surface, speeding recovery.",
      "Pain Relief: Reduces discomfort from conditions like arthritis and fibromyalgia.",
      "Detoxification: Stimulates the lymphatic system for toxin removal.",
      "Reduction of Inflammation: Alleviates pain and swelling."
    ],
    image: Cupping
  },
  {
    id: 8,
    therapy: "TENS Machine",
    description: "TENS (Transcutaneous Electrical Nerve Stimulation) uses low-voltage electrical currents to relieve .",
    whyChoose: "At MantraFlex, TENS is a non-invasive, drug-free pain relief solution used for acute and chronic pain, including conditions like back pain, neck pain, arthritis, and muscle spasms.",
    benefits: [
      "Pain Relief: Uses electrical stimulation to block pain signals.",
      "Improved Circulation: Promotes blood flow to affected areas.",
      "Non-invasive: A safe, drug-free treatment option.",
      "Versatile: Effective for both acute and chronic pain."
    ],
    image: TENS
  },
]

const Services = () => {
  const navigate = useNavigate();

  const handleLearnMoreClick = (id) => {
    navigate(`/services/therapy${id}`);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <Layout>
      <div className="service-section">
        <div className="service-section-content">
          <h1 >Our Services</h1>
          <p>We provide a comprehensive range of physiotherapy services tailored to help you align, strengthen, and thrive in your 
            journey toward better health and wellness. Our expert team is dedicated to addressing your unique needs, whether it's 
            pain relief, injury recovery, or enhancing mobility.</p>
        </div>
      </div>

      <section className="specialization">
        <div className="specialization-div">
          <h2 className="specialization-heading">Therapist Specialization</h2>
          <p className="specialization-info">Discover our specialized therapies, delivered by highly skilled and renowned 
            physiotherapists with extensive experience. Our experts are dedicated to providing exceptional 
            care tailored to your needs.</p>
        </div>
        <div className="card-content">
          {experties.map((item) => (
            <div key={item}>
              <div className="card-box" onClick={() => handleLearnMoreClick(item.id)}>
                <div className='check-img'><img src={check} /></div>
                <h3 className="therapy-heading">{item.therapy}</h3>
                <p className="therapy-info">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <h2 className="specialization-heading" style={{ marginTop: '4rem' }}>Explore Our other services</h2>
      <div className="services-page">
        {services.map((service) => (
          <div
            key={service.id}
            className={`service-card service-card-${service.id} ${service.id % 2 === 0 ? 'even' : 'odd'}`}
          >
            <div className="card-image">
              <img src={service.image} alt={service.title} />
            </div>
            <div className="card-content">
              <h2>{service.therapy}</h2>
              <p>{service.description}</p>
              <button
                className="glow-button"
                onClick={() => handleLearnMoreClick(service.id)}
              >
                Learn More
              </button>
            </div>
          </div>
        ))}
      </div>
      <QuotesSlider />
    </Layout>
  );
};

export default Services;